
export class SetCheckedLeads {
  static readonly type = '[Set checked leads] Set checked leads';

  constructor(public leads: number[],public checkAll: boolean) {
  }
}

export class MarkCheckedLeadAsReadUnread {
  static readonly type = '[Checked Lead] Mark checked lead as read';

  constructor(public leadId: number) {
  }
}

